import * as React from 'react'

import { LEADS_FOR_PARENT_QUERY } from 'main/gql/lead'
import { LEAD_BOOKMARK_MUTATION } from 'main/gql/lead'
import { User_user } from 'main/gql/user'
import { Mutation } from 'react-apollo'
import segment from 'util/analytics/segment'
import { LeadBookmark } from '../../../gql/lead/__generated__/LeadBookmark'
import { isModalRequired } from './BookmarkAuthModal'
import Icon, { Style } from './Icon'

interface IProps {
  schoolId: number
  style: Style
  user: User_user | null
  onRequestOpenAuthModal: () => void
}

export default function Unbookmarked(props: IProps) {
  const { schoolId, style, user, onRequestOpenAuthModal } = props

  return (
    <Mutation<LeadBookmark>
      mutation={LEAD_BOOKMARK_MUTATION}
      refetchQueries={[{ query: LEADS_FOR_PARENT_QUERY }]}
    >
      {mutate => (
        <Icon
          isBookmarked={false}
          style={style}
          onClick={() => {
            if (user) {
              trackBookmarkEvent(schoolId)
              mutate({ variables: { schoolId } })
              if (isModalRequired(user)) onRequestOpenAuthModal()
            } else {
              onRequestOpenAuthModal()
            }
          }}
        />
      )}
    </Mutation>
  )
}

function trackBookmarkEvent(schoolId: number) {
  segment.track('Program Added To Favorites', { school_id: schoolId })
}
